var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total-value",style:({ color: _vm.textColor })},[_vm._v(" "+_vm._s(_vm.balanceText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }